<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container">

      <div class="panel">
        <div class="top">
          <div class="header">
            <a>
              <img src="~@/assets/logo400x400.png" class="logo" alt="logo">
              <span class="title">{{platformName}}</span>
              <!--<span class="title">队列数据一体化平台</span>-->

            </a>
          </div>
          <div class="desc">
            {{companyDescription}}
            <!--队列数据一体化平台身份认证中心-->
          </div>
        </div>
        <!--<div class="title">请登录</div>-->
        <div class="view">
          <route-view></route-view>
        </div>

      </div>

      <div class="footer">
        <!--<div class="links">-->
        <!--<a href="http://doc.jeecg.com" target="_blank">帮助</a>-->
        <!--<a href="https://github.com/zhangdaiscott/jeecg-boot" target="_blank">隐私</a>-->
        <!--<a href="https://github.com/zhangdaiscott/jeecg-boot/blob/master/LICENSE" target="_blank">条款</a>-->
        <!--</div>-->
        <div class="copyright">
          Copyright &copy; 2021 四川大学华西医院. All Rights Reserved <a class="copyright" href="https://beian.miit.gov.cn/#/Integrated/index">{{ icp }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RouteView from "@/components/layouts/RouteView"
  import { mixinDevice } from '@/utils/mixin.js'

  export default {
    name: "UserLayout",
    components: { RouteView },
    mixins: [mixinDevice],
    data () {
      return {
        company:window._CONFIG.company,
        platformName:window._CONFIG.platformName,
        companyDescription:window._CONFIG.companyDescription,
        icp:window._CONFIG.icp
      }
    },
    mounted () {
      document.body.classList.add('userLayout')
    },
    beforeDestroy () {
      document.body.classList.remove('userLayout')
    },
  }
</script>

<style lang="less" scoped>
  .panel{
    padding: 10px;
    width: 600px;
    position: absolute;
    right: calc((100vw - 600px) / 2);
    top: calc((100vh - 526px) / 2);
    .title{
      font-size: 20px;
      color: white;
      text-align: center;
    }
    .view{
      margin-left: 100px;
      border-radius: 10px;
      background-color: transparent !important;
      width: 400px;
      
      /* 确保所有子元素都继承透明背景 */
      & > * {
        background-color: transparent !important;
      }
      
      /* 修复可能的白色背景 */
      .ant-card,
      .ant-tabs,
      .ant-form,
      .ant-row,
      .ant-col,
      .ant-form-item,
      .ant-input-wrapper,
      .ant-input,
      .ant-btn{
        background-color: transparent !important;
      }
    }
  }
  /*@media screen and (max-width: 1200px) {*/
  /**/
  /*}*/
  #userLayout.user-layout-wrapper {
    height: 100%;
    &.mobile {
      .container {
        .main {
          max-width: 368px;
          width: 98%;
        }
      }
    }

    .container {
      width: 100%;
      min-height: 100%;

      background-image: url(~@/assets/background.png);
      background-size: 100% 100%;
      padding: 110px 0 144px;
      position: relative;
      a {
        text-decoration: none;
      }

      .top {
        text-align: center;

        .header {
          height: 44px;
          line-height: 44px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-size: 33px;
            color: white;
            font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
            font-weight: 600;
            position: relative;
            top: 2px;
          }
        }
        .desc {
          font-size: 14px;
          color: white;
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .main {
        min-width: 260px;
        width: 368px;
        margin: 0 auto;
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          color: white;
          font-size: 14px;
        }
      }
    }
  }
</style>